export function getApiErrorMessage(error: any): string {
  if (error?.response?.status === 500) {
    return "Erro interno do backend.";
  }

  if (error?.response?.data?.error) {
    return error.response.data.error;
  }

  if (error?.response?.data) {
    const data = error.response.data;

    return typeof data === "object"
      ? Object.entries(data)
          .map(([key, value]) => `${key}: ${value}`)
          .join("\n")
      : String(data);
  }

  return "Erro desconhecido, verifique os dados e tente novamente.";
}
